"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCrossellModule = exports.TealiumCrossellData = void 0;
var features_1 = require("../features");
Object.defineProperty(exports, "TealiumCrossellData", { enumerable: true, get: function () { return features_1.TealiumCrossellData; } });
var hooks_1 = require("../hooks");
Object.defineProperty(exports, "useCrossellModule", { enumerable: true, get: function () { return hooks_1.useCrossellModule; } });
//# sourceMappingURL=index.js.map